<div class="dashboard-card">
  <div class="dashboard-card-title">{{ displayTitle | labelsProvider }}</div>
  <div class="dashboard-card-redirect">
    <img [src]="logoPath" />
    @if (withRedirect) {
      <app-anchor-link [navigation]="href">{{ redirectText }}</app-anchor-link>
    } @else {
      <app-anchor-link navigation="" (clicked)="linkClicked()">{{ redirectText }}</app-anchor-link>
    }
  </div>
</div>
